import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { StripeAppliesTo } from '@/modules/billing/models/stripe/StripeAppliesTo';

export class StripeCoupon extends BaseModel {
  public id: string;

  public amountOff?: number;

  public metadata: Record<string, unknown>;

  public name: string;

  public percentOff?: number;

  public appliesTo: StripeAppliesTo | null;

  constructor(model: Partial<StripeCoupon> = {}) {
    super();

    this.id = model.id as string;
    this.amountOff = model.amountOff;
    this.metadata = model.metadata as Record<string, unknown>;
    this.name = model.name as string;
    this.percentOff = model.percentOff;
    this.appliesTo = StripeAppliesTo.mapModelOrNull(model.appliesTo);
  }

  get isFullPaymentDiscount(): boolean {
    return !!this.metadata.isFullPaymentDiscount;
  }

  getValueOfDiscount(value: number): number {
    return this.amountOff
      ? Math.min(this.amountOff, value)
      : (value * (this.percentOff ?? 0)) / 100;
  }
}
